import React, { createContext, useEffect, useState } from "react";
import theme from "./utils/theme";
import { ThemeProvider } from "@mui/material";
import { Loader } from "./controls";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Forgot, Login } from "./component/auth";
import "./styles/App.scss";
import "./styles/Style.scss";
import SiteRoute from "./pages/SiteRoute";
import { API, actions, endpoints } from "./api/api";
import { useTranslation } from "react-i18next";

export const AppContext = createContext({});

const App = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [authUser, setAuthUser] = useState();
  const [branch, setBranch] = useState({});
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    setLoader(true);
    API(endpoints.Auth + actions.GetAuthUser).get((res) => {
      if (res && res.status === 200 && res.result) {
        setAuthUser(res.result);
      } else navigate("/auth");
      setLoader(false);
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    authUser && i18n.changeLanguage(authUser.language || "en");
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider
        value={{
          loader,
          setLoader,
          authUser,
          setAuthUser,
          branch,
          setBranch,
          branches,
          setBranches,
        }}
      >
        <Loader show={loader} />
        <Routes>
          <Route
            path="/*"
            element={authUser ? <SiteRoute /> : !loader && <Auth />}
          />
        </Routes>
      </AppContext.Provider>
    </ThemeProvider>
  );
};

const Auth = () => (
  <Routes>
    <Route path="/" element={<Navigate to="auth" />} />
    <Route path="/auth">
      <Route path="forgot" element={<Forgot />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
);

export default App;
